/* assets/mc2-shipping-account.js — Chicago Screws / MC2 — CL-0072
   Persists the shipping-account fields (carrier + account number + service
   level) to cart attributes on change, via /cart/update.js. Horizon checkout
   uses saved cart state (its note field live-saves the same way), so these must
   be written to the cart, not just posted with the form. Delegated on document
   so it survives cart-drawer re-renders (morphs). Loaded site-wide from
   snippets/cart-items-component.liquid, which renders on every page via the
   drawer. */
(function () {
  if (window.__mc2ShipAcctBound) return;
  window.__mc2ShipAcctBound = true;
  var timer = null;

  function currentValues() {
    var box = document.querySelector('[data-shipping-account]');
    if (!box) return null;
    var carrier = box.querySelector('input[name="attributes[Shipping Carrier]"]:checked');
    var acct = box.querySelector('input[name="attributes[Shipping Account Number]"]');
    var svc = box.querySelector('input[name="attributes[Shipping Service Level]"]');
    return {
      'Shipping Carrier': carrier ? carrier.value : '',
      'Shipping Account Number': acct ? acct.value.trim() : '',
      'Shipping Service Level': svc ? svc.value.trim() : ''
    };
  }

  function persist() {
    var attrs = currentValues();
    if (!attrs) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function schedule(delay) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(persist, delay);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-shipping-account]')) schedule(150);
  });
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('[data-shipping-account]') && e.target.type === 'text') schedule(500);
  });
})();
